export default __webpack_public_path__ + "static/media/T8-output3.cdb6d4ec.png";